import quotesStore, { QuotesStore } from "./quotesStore";
import resourcesStore, { ResourcesStore } from "./resourcesStore";
import rootStore, { RootStore } from "./rootStore";
import notificationStore, { NotificationStore } from "./notificationStore";
export type Store = {
  rootStore: RootStore;
  quotesStore: QuotesStore;
  resourcesStore: ResourcesStore;
  notificationStore: NotificationStore;
};

export const serverUrl =
  process.env.REACT_APP_SERVER_URL ?? "http://localhost:5000";

const initStore: Store = {
  rootStore,
  quotesStore,
  resourcesStore,
  notificationStore,
};

export default initStore;
